<template>
    <div class = 'officialAccount'>
        <div class = 'officialAccount-showContent'>
            <div class = 'officialAccount-showContent-desc-box'>

                    <div class = 'officialAccount-showContent-img'>
                        <a :href="'//space.bilibili.com/' + officialMid" target="_blank" :title = "'//space.bilibili.com/' + officialMid" v-href>
                            <div class="common-lazy-img officialAccount-showContent-userIcon">
                                <img alt="" :src="official.face" class = ''>
                            </div>
                        </a>
                        <img src="../assets/images/classroom/user-label.png" alt="label" class = 'officialAccount-showContent-userLabel'>
                    </div>

                <div class = 'officialAccount-showContent-title-box'>
                    <h5 class = 'officialAccount-showContent-title'>
                        <a :href="'//space.bilibili.com/' + officialMid" target="_blank" :title ="'//space.bilibili.com/' + officialMid" v-href>
                            <span class = 'officialAccount-showContent-name'>{{ official.title }}</span>
                        </a>
                        <span class = 'officialAccount-showContent-lv' v-if = 'official.level' :style='`background-position: ${lvposition}`'></span>
                    </h5>
                    <p class = 'officialAccount-showContent-desc'>{{ official.sign }}</p>
                </div>
            </div>

            <div>
                <div class = 'officialAccount-showContent-btn' v-if = '!isFoucs' @click = 'isJumpLogin'>关注</div>
                <div class = 'officialAccount-showContent-btn focus' v-else @click = 'isJumpLogin'>已关注</div>
            </div>

        </div>
    </div>
</template>
<script>
import { quickLogin, trimHttp } from 'g-public/utils';

import http from 'g-public/apis/http'
import cookie from 'g-public/utils/cookie';
import { mapState } from 'vuex';

export default {
    data () {
        return {
            isFoucs: false,
            attribute: 0,
            official: {
                level: 1,
                title: '',
                sign: '',
                face: ''
            },
            officialBgStyle: {
                background: '#D8D8D8'
            }
        };
    },

    computed: {
        ...mapState(['loginInfo']),

        lvposition () {
            const list = {
                1: '-21px -46px',
                2: '-21px -82px',
                3: '-21px -118px',
                4: '-21px -154px',
                5: '-21px -190px',
                6: '-21px -226px',
                7: '-21px -262px',
                8: '-21px -298px',
                9: '-21px -334px'
            };
            if (!this.official.level) return '';
            return list[this.official.level];
        },

        officialMid () {
            return process.env.NODE_ENV !== 'production' ? 27515432 : 458165375;
        }
    },

    watch: {
        loginInfo(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.fetchUserStatus();
            }
        }
    },

    mounted() {
        this.fetchOfficalAccounts();
    },

    methods: {

        fetchUserStatus() {
            // 未登录直接显示
            if (!this.loginInfo.isLogin) return this.$emit('update:show');
            http({
                method: 'GET',
                url: 'x/relation',
                params: {
                    fid: this.officialMid
                },
                include: true
            }).then(res => {
                if (res.status === 200 && res.data && res.data.code === 0) {
                    const data = res.data.data;

                    this.attribute = data.attribute;
                    this.isFoucs = data.attribute === 1 || data.attribute === 2 || data.attribute === 6;

                    if (!this.isFoucs) this.$emit('update:show');
                }
            });
        },

        fetchOfficalAccounts() {
            http({
                method: 'GET',
                url: 'x/web-interface/card',
                params: {
                    mid: this.officialMid
                },
                include: true
            }).then(res => {
                if (res.status === 200 && res.data && res.data.code === 0) {

                    const data = res.data.data;

                    if (!data) return;

                    this.official.level = data.card.level_info.current_level;
                    this.official.title = data.card.name;
                    this.official.sign = data.card.sign;
                    this.official.face = trimHttp(data.card.face);

                }
            });
        },

        handleFoucs(e) {
            http({
                method: 'POST',
                url: 'x/relation/modify',
                params: {
                    fid: this.officialMid,
                    act: this.isFoucs ? 2 : 1, // 1关注 2取消关注
                    re_src: 0, // 新的调用关注不需要传src
                    // cross_domain: true,
                    csrf: cookie.get('bili_jct') || ''
                },
                include: true
            }).then(res => {
                if (res.status === 200 && res.data.code === 0) {
                    this.isFoucs = !this.isFoucs;
                } else {
                    this.$message.info(this.isFoucs ? '取消关注失败，请重试！' : '关注失败，请重试！', e.target);
                }
            });
        },

        isJumpLogin(e) {
            if (!this.loginInfo.isLogin) quickLogin();
            else this.handleFoucs(e);
        }
    }
};
</script>

<style lang="less" scoped>
.cur {
    cursor: pointer;
}

.officialAccount {
    font-size: 14px;
    position: relative;
}

.officialAccount-showContent {
    width: 340px;
    // height: 167px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0 1px 20px 0 rgba(0,0,0,0.10);
    border-radius: 2px;
    background: #fff;
}

.officialAccount-showContent-desc-box {
    display: flex;
    // align-items: center;
}

.officialAccount-showContent-img {
    width: 60px;
    height: 60px;
    // background: #D8D8D8;
    border-radius: 50%;
    // overflow: hidden;
    margin-right: 15px;
    position: relative;
}

.officialAccount-showContent-userIcon {
    width: 100%;
    height: 100%;
    &>img {
        border-radius: 50%;
    }
}

.officialAccount-showContent-title-box {
    flex: 1;
}

.officialAccount-showContent-title {
    font-size: 18px;
    color: #212121;
    line-height: 26px;
    font-weight: 500;

    &:hover {
        .officialAccount-showContent-name {
                    color: #0ba395;
        }
    }
}

.officialAccount-showContent-name {
    display: inline-block;
    vertical-align: middle;
    color: #212121;
}

.officialAccount-showContent-desc {
    font-size: 14px;
    color: #999999;
    word-break: break-word;
}

.officialAccount-showContent-lv {
    display: inline-block;
    width: 28px;
    height: 16px;
    line-height: 16px;
    vertical-align: middle;

    background-repeat: no-repeat;
    // background-position: -21px -190px;
    background-image: url(//s1.hdslb.com/bfs/static/jinkela/space/asserts/level.png);
    // color: #fff;
    // font-size: 12px;
    // text-align: center;
    // background-color: #FF6B01;
    // border-radius: 4px;
}

.officialAccount-showContent-btn {
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    background: #0BA395;
    border-radius: 2px;
    border-radius: 2px;
    margin-top: 20px;
    text-align: center;
    cursor: pointer;
    user-select: none;

    &:focus {
        border: none;
    }

    &:focus {
        border: none;
    }

    &.focus {
        background: #F4F4F4;
        color: #999;
    }
}

.officialAccount-showContent-userLabel {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99;
}


</style>